var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avaContainer"},[(_vm.currentAnimation)?_c('img',{staticStyle:{"width":"300px","height":"540px"},attrs:{"src":_vm.animationPath}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }